import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AuditLogLite } from '../+models/trip-audit.model';

@Component({
  selector: 'sd-portal-audit-detail-v2',
  templateUrl: './audit-detail-v2.component.html',
  styleUrls: ['./audit-detail-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuditDetailV2Component {
  @Input() audit: AuditLogLite;

  constructor() {}
}
